export default __webpack_public_path__ + "static/media/gel8.03bd0ff4.svg";